module.exports = __webpack_public_path__ + "static/media/ram.7332538d.jpg";